import { render, staticRenderFns } from "./CitasComentariosValidacion.vue?vue&type=template&id=47ddb350"
import script from "./CitasComentariosValidacion.vue?vue&type=script&lang=js"
export * from "./CitasComentariosValidacion.vue?vue&type=script&lang=js"
import style0 from "./CitasComentariosValidacion.vue?vue&type=style&index=0&id=47ddb350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports